import { useCallback, type ChangeEventHandler } from "react";
import { ExperiencePhase } from "../hooks/useRtfmLifecycle";

interface DebugPhasePickerProps {
  value: ExperiencePhase;
  onChange: (phase: ExperiencePhase) => void;
}

/**
 * Small debug control to force the experience phase.
 */
export const DebugPhasePicker = ({ value, onChange }: DebugPhasePickerProps) => {
  const handleChange = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    (e) => onChange(e.target.value as ExperiencePhase),
    [onChange],
  );

  return (
    <div className="flex items-center gap-2 text-primary">
      <span className="opacity-80">Phase</span>
      <select
        aria-label="Debug: Experience Phase"
        className="bg-transparent text-primary outline-none"
        value={value}
        onChange={handleChange}
      >
        <option value="queue">queue</option>
        <option value="preparing">preparing</option>
        <option value="active">active</option>
        <option value="ending">ending</option>
        <option value="post">post</option>
      </select>
    </div>
  );
};

DebugPhasePicker.displayName = "DebugPhasePicker";
